<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>同龄分群</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="考试类型">
              <Select v-model="queryParam.examType" clearable placeholder="请选择考试类型">
                <Option value="PLACEMENT">入门测</Option>
                <Option value="SUMMATIVE">阶段测</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="年龄档">
              <Select v-model="queryParam.ageBand" clearable placeholder="请选择年龄档">
                <Option value="LOW">低档（3-5）</Option>
                <Option value="MID">中档（6-8）</Option>
                <Option value="HIGH">高档（9+）</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
        </div>
      </Form>
    </div>
    <p style="margin: 8px 0; color: #888">样本 n&lt;1000 时学生端不展示全国/同城对照。本页只读，月度校准属 P3。</p>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/cohorts/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
  </div>
</template>

<script>
export default {
  name: 'MexScoreCohortList',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      tableColumns: [
        { title: 'ID', key: 'id', width: 80, ellipsis: true },
        { title: '考试类型', key: 'examType', width: 120, ellipsis: true, render: (h, params) => h('span', this.examTypeLabel(params.row.examType)) },
        { title: '年龄档', key: 'ageBand', width: 140, ellipsis: true, render: (h, params) => h('span', this.ageBandLabel(params.row.ageBand)) },
        { title: '城市码', key: 'cityCode', width: 120, ellipsis: true },
        { title: '样本 n', key: 'sampleN', width: 100, ellipsis: true },
        { title: '平均分', key: 'avgScore', width: 100, ellipsis: true },
        { title: '更新时间', key: 'gmtModified', width: 180, ellipsis: true }
      ]
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    examTypeLabel (code) {
      if (code === 'PLACEMENT') return '入门测'
      if (code === 'SUMMATIVE') return '阶段测'
      return code || '—'
    },
    ageBandLabel (code) {
      if (code === 'LOW') return '低档（3-5）'
      if (code === 'MID') return '中档（6-8）'
      if (code === 'HIGH') return '高档（9+）'
      return code || '—'
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';
</style>



// WEBPACK FOOTER //
// MexScoreCohortList.vue?beec7c20